import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { AuthStore } from '@lemsar/storage/stores/auth.store';
import { first, switchMap } from 'rxjs/operators';
import { User } from '@lemsar/auth/domains/models/user';
import { of } from 'rxjs/observable/of';

@Injectable()
export class GuestGuard implements CanActivate {
    public constructor(private authStore: AuthStore, private router: Router) {}

    public canActivate(): Observable<boolean> {
        return this.authStore.user$.pipe(
            first(),
            switchMap((user: User) => {
                if (user.id) {
                    this.router.navigate(['/']);
                    return of(false);
                }

                return of(true);
            }),
        );
    }
}



// WEBPACK FOOTER //
// ./src/lemsar/auth/guards/guest.guard.ts